import React, { useState } from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";
import ByzMuiTypography from "../../../inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";

// CKAPISIZ;446187;19.03.2025
interface ByzNurseOkeyButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const StyledOkeyButton = styled(Button)<{ hoverState?: boolean }>(
  ({ hoverState }) => ({
    color: "#1E88E5",
    border: "1px solid #1E88E5",
    backgroundColor: hoverState ? "#63B4FF33" : "#63B4FF33",
    opacity: hoverState ? 1 : 0.9,
    transition: "0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "#63B4FF33",
      opacity: 1,
    },
  })
);

const ByzNurseOkeyButton = ({ onClick, disabled }: ByzNurseOkeyButtonProps) => {
  const { t } = useTranslate();
  const [hover, setHover] = useState(false);

  return (
    <StyledOkeyButton
      onClick={onClick}
      hoverState={hover}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      disabled={disabled}
    >
      <ByzMuiTypography fontWeight={400} marginLeft="0px">
        {t("buttons.okey")}
      </ByzMuiTypography>
    </StyledOkeyButton>
  );
};

export default ByzNurseOkeyButton;
